<template>
    <div>
        <Motorista v-if="isMotorista"/>
        <Home v-else/>
    </div>
</template>
<script>
import { VueEasyJwt } from 'vue-easy-jwt'
import Home from "@/components/home/home"
import Motorista from "@/components/rastreio/motoristaRastreio"

export default {
    name: 'meHome',
    components: { Home, Motorista },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            level: '',
            isMotorista: false
        }
    },
    methods: {
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
            }
        }
    },
    mounted() {
        this.validaLogin()
        if(this.level==='motorista') {
            this.isMotorista = true
        } else {
            this.isMotorista = false
        }
    }
}
</script>
<style>
</style>